export default "__VITE_ASSET__DmG4WtYf__"